import { render, staticRenderFns } from "./SongAddToCategoriesDialog.vue?vue&type=template&id=77b8d0fa&"
import script from "./SongAddToCategoriesDialog.vue?vue&type=script&lang=js&"
export * from "./SongAddToCategoriesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports